module.exports = __webpack_public_path__ + "static/media/20161208-BALLOON1384_0022122.cfb16790.jpg";